exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml, body \r\n{ \r\n  margin: 0; \r\n  overflow: none;\n}\nbody {\r\n    background-color: #FFF;\n}\nhtml {\n}\r\n\r\n/* Set gray background color and 100% height */\n.fv-app {\r\n  /* equal to footer height to the footer visible*/\r\n  background-color: #fff;\r\n  /* equal to footer height to be sure overall height stays 100% */\r\n  overflow: none;\n}\n.fv-top {\n}\n.fv-siderbar{\r\n  height: 100% ;\r\n  overflow-y:auto;\r\n  overflow-x:auto;\n}\n.fv-content {\r\n  height: 100% ;\r\n  overflow-x: none;\r\n  overflow-y: auto;\n}\n.fv-content:after {\n}\n.fv-sticky-footer {\r\n  background: #365073;\r\n  position: absolute;\r\n  height: 20px; \r\n  color: #eee;\r\n  bottom: 0;\r\n  width: 100%;\r\n  /* Set the fixed height of the footer here */\r\n  line-height: 0px; /* Vertically center the text there */\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = /ytz
// module chunks = 1